import React from 'react';

import { ShareButtons } from '@benzinga/ui';

export interface ShareButtonsBlockProps {
  attrs?: any;
}

export const ShareButtonsBlock: React.FC<ShareButtonsBlockProps> = () => {
  return <ShareButtons buttonLocation="page_share_block" />;
};

// export const Container = styled.div``;
